import { deleteRequest, get, post, publicPost, put } from "../../helpers/apihelpers";

export const CreateDigitalCardService=async(data)=>{
    try {
        const result = await post(`api/digital_card/create`, data);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const UpdateDigitalCardService=async(data,id)=>{
    try {
        const result = await put(`api/digital_card/update/${id}`, data);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const GetDigitalCardService=async(page=1,status,text,from_date,to_date,distributor)=>{
    try {
        const result = await get(`api/digital_card/get?page=${page}&used=${status}&text=${text}&from_date=${from_date}&to_date=${to_date}&distributor=${distributor}`);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const DownloadDigitalCardService=async(page=1,status,text,from_date,to_date,distributor)=>{
    try {
        const result = await get(`api/digital_card/download_excel?page=${page}&used=${status}&text=${text}&from_date=${from_date}&to_date=${to_date}&distributor=${distributor}`);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const DeleteDigitalCardService=async(id)=>{
    try {
        const result = await deleteRequest(`api/digital_card/delete/${id}`);
        return result;
    } catch (err) {
        return err.response;
    }
}

